import React from "react";
import { ArrowUpRight, Github } from "lucide-react";
import SectionLabel from "./SectionLabel";

const PROJECTS = [
  {
    id: "codebase-navigator",
    name: "Codebase-Navigator",
    description:
      "Conversational map for any repo. Ask in plain English, get grounded answers with citations to exact file and line ranges.",
    tags: ["LangChain", "ChromaDB", "OpenAI", "ExpressJS", "Next.js"],
    // image:
    //   "https://images.unsplash.com/photo-1737505599162-d9932323a889",
    live: "https://codebase-nav.onrender.com",
    github: "https://github.com/srivastava-aryan/codebase-navigator",
  },
  {
    id: "code-my-war",
    name: "Code-My-War AI-PR Reviewer",
    description:
      "An AI-powered pull request reviewer that provides automated code quality checks and suggestions.",
    tags: ["Node.js", "Google Gemini", "GitHub API", "JWT", "Express.js"],
    live: "https://code-my-war.onrender.com",
    github: "https://github.com/srivastava-aryan/codewarrior",
  },
  {
    id: "ai-meet",
    name: "AI-Meet",
    description:
      "Real-time meeting copilot that transcribes, summarises action items, and surfaces context from past conversations.",
    tags: [
      "Typescript",
      "Node.js",
      "OpenRouter",
      "Prompt Engineering",
      "React.js",
    ],
    // image:
    //   "https://images.unsplash.com/photo-1770486036751-e55247238964?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwYWJzdHJhY3QlMjBkYXJrJTIwY29kZSUyMHBhdHRlcm58ZW58MHx8fHwxNzgyNjQyMzc2fDA&ixlib=rb-4.1.0&q=85",
    live: "https://aimeet.aryansri.tech",
    github: "https://github.com/srivastava-aryan/ai-meet",
  },
  {
    id: "tracksub",
    name: "TrackSub",
    description:
      "Subscription radar that watches your inbox + bank events and tells you exactly what's bleeding money each month.",
    tags: ["Node.js", "MongoDB", "FireBase", "Tailwind", "Stripe"],
    // image:
    // //   "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY29kaW5nJTIwbW9uaXRvciUyMGFic3RyYWN0fGVufDB8fHx8MTc4MjY0MjM5Mnww&ixlib=rb-4.1.0&q=85",
    live: "https://tracksub.aryansri.tech",
    github: "https://github.com/srivastava-aryan/tracksub",
  },
  {
    id: "reminder-agent",
    name: "Reminder-Agent",
    description:
      "A personal AI agent that reads your emails and reminds you of important tasks, deadlines, and events.",
    tags: ["LangChain", "CronJob", "Email Automation", "Node.js", "React.js"],
    // image:
    //   "https://images.unsplash.com/photo-1682685794700-1e3f5c6b8d4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxwZXJzb25hbCUyMGFpJTIwYWdlbnQlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODI2NDIzOTV8MA&ixlib=rb-4.1.0&q=85",
    github: "https://github.com/srivastava-aryan/reminder-agent",
  },
  {
    id: "url-shortener",
    name: "URL Shortener",
    description:
      "A simple and fast URL shortener service that generates concise links for easy sharing.",
    tags: ["Node.js", "Express.js", "MongoDB", "React.js"],
    // image:
    //   "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx1cmwlMjBzaG9ydGVyfGVufDB8fHx8MTc4MjY0MjQwNnww&ixlib=rb-4.1.0&q=85",
    github: "https://github.com/srivastava-aryan/shorturl",
  },
  {
    id: "weather-webapp",
    name: "Weather WebApp",
    description:
      "A weather application that provides accurate and up-to-date weather information for any location.",
    tags: ["Javascript", "HTML", "CSS", "OpenWeatherMap API"],
    // image:
    //   "https://images.unsplash.com/photo-1564227087193-0f0c9d3a5a4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx3ZWF0aGVyJTIwYXBwfGVufDB8fHx8MTc4MjY0MjQxNnww&ixlib=rb-4.1.0&q=85",
    live: "https://weather-sphere-eevl.onrender.com/",
    github: "https://github.com/srivastava-aryan/weather",
  },
];

const ProjectCard = ({ project, idx }) => {
  return (
    <article
      data-testid={`project-card-${project.id}`}
      className="card-terminal group relative flex flex-col border border-line bg-bg-surface/60"
    >
      <div className="absolute left-3 top-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-ink-secondary">
        <span className="text-accent">[</span>{" "}
        {String(idx + 1).padStart(2, "0")} /
        {String(PROJECTS.length).padStart(2, "0")}{" "}
        <span className="text-accent">]</span>
      </div>
      {/* Image header */}
      {/* <div className="relative aspect-[16/9] overflow-hidden border-b border-line">
        <img
          src={project.image}
          alt={`${project.name} cover`}
          loading="lazy"
          className="h-full w-full object-cover opacity-70 saturate-[0.6] transition duration-700 group-hover:scale-[1.03] group-hover:opacity-90 group-hover:saturate-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-bg-surface via-bg-surface/30 to-transparent" />
        
      </div> */}

      {/* Body */}
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-mono text-xl text-ink-primary">{project.name}</h3>
        <p className="mt-3 font-sans text-sm leading-relaxed text-ink-secondary">
          {project.description}
        </p>

        {/* Tags */}
        <div className="mt-5 flex flex-wrap gap-1.5">
          {project.tags.map((t) => (
            <span
              key={t}
              className="font-mono text-[11px] tracking-tight text-ink-secondary"
            >
              <span className="text-accent/70">[</span>
              <span className="px-1">{t}</span>
              <span className="text-accent/70">]</span>
            </span>
          ))}
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Links */}
        <div className="mt-7 flex items-center gap-4 border-t border-line pt-5 font-mono text-xs uppercase tracking-widest">
          {project.live && (
            <a
              href={project.live}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`project-${project.id}-live`}
              className="inline-flex items-center gap-1.5 text-ink-primary transition hover:text-accent"
            >
              Live
              <ArrowUpRight size={14} />
            </a>
          )}

          {project.live && project.github && (
            <span className="text-ink-dim">/</span>
          )}

          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`project-${project.id}-github`}
              className="inline-flex items-center gap-1.5 text-ink-primary transition hover:text-accent"
            >
              <Github size={14} />
              Source
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative border-b border-line"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <SectionLabel
          index="02"
          label="PROJECTS"
          prompt
          testId="projects-label"
        />

        <div className="mt-4 flex items-baseline justify-between gap-6">
          <h2 className="max-w-2xl font-mono text-3xl leading-tight text-ink-primary md:text-4xl">
            Selected builds —{" "}
            <span className="text-ink-secondary">
              shipped, instrumented, opinionated.
            </span>
          </h2>
          <span className="hidden font-mono text-[11px] uppercase tracking-[0.22em] text-ink-dim md:inline">
            ls -la ./projects
          </span>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {PROJECTS.map((p, i) => (
            <ProjectCard key={p.id} project={p} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
